import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button
} from 'semantic-ui-react'

const CardStaffORRequestUX = (props: any) => {
    return(
      <div>
        <div
          id="CardStaffORRequestUX-div-2"
          style={{ paddingTop: "4px", marginBottom: "-4px" }}>
          
          <Button
            color={props.containerName === "ORRequest" ? "blue":  undefined}
            id="CardStaffORRequestUX-Button-3"
            name="ORRequest"
            onClick={props.onSetContainerName}
            style={{marginLeft: "15px"}}>
            {props.languageUX === "en" ? "OR Request" : "OR Request"}
          </Button>
          <Button
            color={props.containerName === "SelectedOperatingTime" ? "blue":  undefined}
            id="CardStaffORRequestUX-Button-4"
            name="SelectedOperatingTime"
            onClick={props.onSetContainerName}
            style={{marginLeft: "15px"}}>
            {props.languageUX === "en" ? "Select surgery date and time" : "เลือกวันเวลา ผ่าตัด"}
          </Button>
          <Button
            color={props.containerName === "OtherAppointmentOrder" ? "blue":  undefined}
            id="CardStaffORRequestUX-Button-5"
            name="OtherAppointmentOrder"
            onClick={props.onSetContainerName}
            style={{marginLeft: "15px"}}>
            {props.languageUX === "en" ? "Other advance directives" : "คำสั่งล่วงหน้า อื่นๆ"}
          </Button>
        </div>
        <hr
          id="CardStaffORRequestUX-hr-9">
        </hr>
      </div>
    )
}


export default CardStaffORRequestUX

export const screenPropsDefault = {}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStaffORRequestUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: \"4px\", marginBottom: \"-4px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "OR Request",
          "valueEN": "OR Request"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"ORRequest\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardStaffORRequestUX-Button-3"
        },
        "name": {
          "type": "value",
          "value": "ORRequest"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลา ผ่าตัด",
          "valueEN": "Select surgery date and time"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"SelectedOperatingTime\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardStaffORRequestUX-Button-4"
        },
        "name": {
          "type": "value",
          "value": "SelectedOperatingTime"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งล่วงหน้า อื่นๆ",
          "valueEN": "Other advance directives"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"OtherAppointmentOrder\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardStaffORRequestUX-Button-5"
        },
        "name": {
          "type": "value",
          "value": "OtherAppointmentOrder"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStaffORRequestUX-hr-9"
        }
      },
      "seq": 9,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardStaffORRequestUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
